import React, { useEffect, useRef, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router';
import useWindowSize from '../hooks/useWindowSize';
import HeroSlider from '../components/HeroSlider';
import "./service.scss";


const dryCleaningSlider = [
    { src: "dc1.jpg", title: 'Look Good, Feel Great' },
    { src: "dc2.jpg", title: 'Look Good, Feel Great' },
    { src: "dc3.jpg", title: 'Look Good, Feel Great' },
    { src: "dc4.jpg", title: 'Look Good, Feel Great' }
];
const dryCleaningSliderMobile = [
    { src: "dc1.jpg", title: 'Look Good, Feel Great' },
    { src: "dc2.jpg", title: 'Look Good, Feel Great' },
];

const restorationSlider = [
    { src: "res1.jpg", title: 'Look Good, Feel Great' },
    { src: "res2.jpg", title: 'Look Good, Feel Great' },
    { src: "res3.jpg", title: 'Look Good, Feel Great' }
 ];

 const restorationSliderMobile = [
    { src: "res1.jpg", title: 'Look Good, Feel Great' },
    { src: "res2.jpg", title: 'Look Good, Feel Great' },
 ];


const ServiceLayout = () => {
  const { width } = useWindowSize();
  const location = useLocation();
  const dryCleaningRef = useRef(null);
  const restorationRef = useRef(null);
  const [userClickedTab, setUserClickedTab] = useState(false);

  useEffect(() => {
    if (userClickedTab) {
      const timer = setTimeout(() => {
        if (location.pathname.includes('dry-cleaning') && dryCleaningRef.current) {
          dryCleaningRef.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        } else if (location.pathname.includes('shoes-and-bag-restoration') && restorationRef.current) {
          restorationRef.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        }
        setUserClickedTab(false);
      },1000); 

      return () => clearTimeout(timer);
    }
  }, [location.pathname, userClickedTab]);

  return (
    <div className="servicePage px-0">
      <div className="main-banner">
          {location.pathname.includes('dry-cleaning') && (
            width >1024 ?<HeroSlider heroImages={dryCleaningSlider} dir="service/DryCleaning" type="desktop"/> :<HeroSlider heroImages={dryCleaningSliderMobile} dir="service/DryCleaning" type="mobile"/>
          )}
          {location.pathname.includes('shoes-and-bag-restoration') && (
            width >1024 ?<HeroSlider heroImages={restorationSlider} dir="service/Restoration" type="desktop"/> :<HeroSlider heroImages={restorationSliderMobile} dir="service/Restoration" type="mobile"/>
        )}   
      </div>
      <div className="service-tab">
        <NavLink
          ref={dryCleaningRef}
          className="btn btn-md base-btn outlined overflowHidden"
          to="/service/dry-cleaning"
          onClick={() => setUserClickedTab(true)}
        >
          Laundry & Dry Cleaning
        </NavLink>
        <NavLink
          ref={restorationRef}
          className="btn btn-md base-btn outlined overflowHidden"
          to="/service/shoes-and-bag-restoration"
          onClick={() => setUserClickedTab(true)}
        >
          Shoes & Bag Restoration
        </NavLink>
      </div>
      <Outlet />
    </div>
  );
};

export default ServiceLayout;
